import * as React from "react";
import { useCallback } from "react";
import { classNames } from "./utils.js";
import { stylesheet } from "typestyle";
import { percent } from "csx";
export var DialogAlignment;
(function (DialogAlignment) {
    DialogAlignment["Center"] = "Center";
    DialogAlignment["Bottom"] = "Bottom";
    DialogAlignment["Left"] = "Left";
    DialogAlignment["FullScreen"] = "FullScreen";
    // more to come...
})(DialogAlignment || (DialogAlignment = {}));
export function Dialog(props) {
    const { open, onBackdropClick, children, align = DialogAlignment.Center, class: dialogClass } = props;
    const handleClick = useCallback((e) => {
        e.stopPropagation();
    }, []);
    return (React.createElement("div", { className: classNames(styles.backDrop, open ? styles.backDropOpen : styles.backDropClosed), onClick: onBackdropClick },
        React.createElement("div", { className: classNames(styles.dialog, open ? styles.dialogOpen : styles.dialogClosed, getDialogAlignmentClass(align, open), dialogClass), onClick: handleClick }, children)));
}
export function DialogHeader({ children, title }) {
    return (React.createElement("div", { className: styles.header },
        title && (React.createElement(DialogTitle, null, title)),
        children));
}
export function DialogTitle({ children }) {
    return (React.createElement("div", { className: styles.title }, children));
}
export function DialogContent({ children }) {
    return (React.createElement("div", { className: styles.content }, children));
}
export function DialogFooter({ children }) {
    return (React.createElement("div", { className: styles.footer }, children));
}
function getDialogAlignmentClass(alignment, open) {
    switch (alignment) {
        case DialogAlignment.Center:
            return classNames(styles.dialogCenter, open && styles.dialogCenterActive);
        case DialogAlignment.Bottom:
            return classNames(styles.dialogBottom, open && styles.dialogBottomActive);
        case DialogAlignment.Left:
            return classNames(styles.dialogLeft, open && styles.dialogLeftActive);
        case DialogAlignment.FullScreen:
            return classNames(styles.dialogFullScreen, open && styles.dialogFullScreenActive);
    }
}
const styles = stylesheet({
    backDrop: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        transition: "background-color 0.25s",
        zIndex: 999
    },
    backDropOpen: {
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        visibility: "visible",
    },
    backDropClosed: {
        backgroundColor: "rgba(0, 0, 0, 0)",
        visibility: "hidden",
    },
    dialog: {
        position: "absolute",
        transformOrigin: "center center",
        transition: "transform 0.25s, visibility 0.25s",
        background: "var(--color-background)",
        color: "var(--color-foreground)",
        boxShadow: "0 1px 7px #000",
    },
    dialogOpen: {
        visibility: "visible",
        opacity: 1,
    },
    dialogClosed: {
        visibility: "hidden",
        opacity: 0,
    },
    dialogCenter: {
        left: percent(50),
        top: percent(50),
        transform: "translateX(-50%) translateY(-50%) scale(0)",
    },
    dialogCenterActive: {
        transform: "translateX(-50%) translateY(-50%) scale(1)",
    },
    dialogFullScreen: {
        top: percent(50),
        marginLeft: percent(2),
        marginRight: percent(2),
        width: percent(96),
        transform: "translateX(-5%) translateY(-50%) scale(0)",
    },
    dialogFullScreenActive: {
        transform: "translateY(-50%) scale(1)",
    },
    dialogBottom: {
        left: percent(50),
        bottom: 0,
        transformOrigin: "bottom center",
        transform: "translateX(-50%) translateY(100%) scale(0)",
    },
    dialogBottomActive: {
        transform: "translateX(-50%) translateY(0) scale(1)",
    },
    dialogLeft: {
        left: 0,
        top: percent(50),
        transformOrigin: "left center",
        transform: "translateX(-100%) translateY(-50%) scale(0)",
    },
    dialogLeftActive: {
        transform: "translateX(0) translateY(-50%) scale(1)",
    },
    header: {},
    title: {
        textAlign: "center",
        fontSize: "1.5em",
        fontWeight: 500,
        padding: "0.75em 1.5em",
    },
    content: {
        padding: "0.75em 1.5em",
    },
    footer: {
        textAlign: "center",
        padding: "0.75em 1.5em",
    }
});
//# sourceMappingURL=dialog.js.map